export function includeChargebeeScript() {
  if (document) {
    const s = document.createElement('script')
    s.setAttribute('src', 'https://js.chargebee.com/v2/chargebee.js')
    document.body.appendChild(s)
  }
}

export const handleOpenChargebeeCheckout = {
  type: 'function',
  required: true,
}

export const openChargebeeCheckout = (opts) => {
  const {
    hostedPageData,
    onLoaded = () => {},
    onError = () => {},
    onSuccess = () => {},
    onClose = () => {},
    onStep = () => {},
  } = opts

  const Chargebee = (window as any).Chargebee

  if (Chargebee) {
    const cbInstance = Chargebee.init({
      site: import.meta.env.VITE_CHARGEBEE_SITE,
    })

    cbInstance.openCheckout({
      hostedPage() {
        return new Promise((resolve) => {
          resolve(hostedPageData)
        })
      },
      loaded() {
        onLoaded()
      },
      error() {
        onError()
      },
      success(hostedPageId: string) {
        onSuccess(hostedPageId)
      },
      close() {
        onClose()
      },
      step(currentStep: string) {
        onStep(currentStep)
      },
    })
  }
}
